class QuizSlider extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('ul.slider-items');
		this.sliderWrapper = this.querySelector('.slider-wrapper');
		this.sliderItems = this.querySelectorAll('li.slider-item');
		this.prevButton = this.querySelector('.slider-button-prev');
		this.nextButton = this.querySelector('.slider-button-next');
		this.sliderLastItem = this.sliderItems[this.sliderItems.length - 1];
		this.sliderFirstItem = this.sliderItems[0];
		this.size = 1.5; // total items to display
		this.activeClass = true; // if middle item should get an active class
		this.gap = 10; // gap between slides in px
		this.width = 0;
		this.height = 0;
		this.initialInitEnded = false;
    
        this.nextEvent = this.next.bind(this);
        this.prevEvent = this.prev.bind(this);

		// touch drag variables
		this.touchstartX = 0;
		this.touchendX = 0;

		this.init();

		const resizeObserver = new ResizeObserver((entries) => this.init());
		resizeObserver.observe(this.sliderWrapper);
	}

	init() {
		if (!this.initialInitEnded) {
			this.prevButton.addEventListener('click', this.move.bind(this));
			this.nextButton.addEventListener('click', this.move.bind(this));

			this.slider.addEventListener('touchstart', (e) => {
				this.touchstartX = e.changedTouches[0].screenX;
			});
			this.slider.addEventListener('touchend', (e) => {
				this.touchendX = e.changedTouches[0].screenX;
				this.checkDirection();
			});

			this.setMinItems();
		}

		this.width = this.getSize();
		this.slider.style.height = this.getHeight();
		this.slider.style.transform = `translateX(-${this.width / 1.3}px)`;

		if (!this.initialInitEnded) {
			this.clone('prev');
		}

		this.build();
		this.initialInitEnded = true;
	}
	setMinItems() {
		const minItems = this.size + 3;
		if (this.sliderItems.length < minItems) {
			let itemsLength = this.sliderItems.length;
			for (let i = 0; i < itemsLength; i++) {
				let c = this.sliderItems[i].cloneNode(true);
				this.slider.append(c);
			}
		}
		this.sliderItems = this.querySelectorAll('li.slider-item');
		if (this.sliderItems.length < minItems) {
			this.setMinItems();
		}
	}
	getSize() {
		let w = this.slider.clientWidth;
		w = w / this.size - this.gap;
		return w;
	}
	getHeight() {
		let h = this.sliderItems[0].clientHeight;

		// check if another item is higher
		for (let i = 0; i < this.sliderItems.length; i++) {
			let item_h = this.sliderItems[i].clientHeight;
			if (item_h > h) {
				h = item_h;
			}
		}
		h = h;
		return h + 'px';
	}
	build() {
		this.sliderItems = this.querySelectorAll('li');
		if (this.activeClass) {
			this.setActive();
		}

		let l = this.width * -1;
		for (let i = 0; i < this.sliderItems.length; i++) {
			this.sliderItems[i].style.width = this.width + 'px';
			this.sliderItems[i].style.left = l + 'px';
			l = l + this.width;

			if (i > 0) {
				let g = this.gap / this.size;
				l = l + this.gap + g;
			}
		}

        
        this.addMoveListeners()
	}
	clone(pos = 'next') {
		let item = null;
		if (pos === 'next') {
			item = this.sliderItems[0];
		} else {
			item = this.sliderItems[this.sliderItems.length - 1];
		}

		let c = item.cloneNode(true);

		if (pos === 'next') {
			this.slider.append(c);
		} else {
			this.slider.prepend(c);
		}

		item.remove();
	}
	move(event) {
        event.stopPropagation();
		event.currentTarget.name === 'next' ? this.next() : this.prev();
	}
	next() {
		this.clone('next');
		this.build();
	}
	prev() {
		this.clone('prev');
		this.build();
	}
	setActive() {
		this.sliderItems = this.querySelectorAll('li');
		let m = Math.round(this.size / 2);

		for (let i = 0; i < this.sliderItems.length; i++) {
			this.sliderItems[i].classList.remove('active');

			if (i - 1 === m) {
				this.sliderItems[i].classList.add('active');
			}
		}
	}
    addMoveListeners() {
        this.sliderItems = this.querySelectorAll('li');

        for (let i = 0; i < this.sliderItems.length; i++) {
			this.sliderItems[i].removeEventListener('click', this.nextEvent)
			this.sliderItems[i].removeEventListener('click', this.prevEvent)
		}

        const activeSlide = this.querySelector('li.active');
        const nextSibling = activeSlide.nextElementSibling;
        const prevSibling = activeSlide.previousElementSibling;

        prevSibling.addEventListener('click', this.prevEvent)
        nextSibling.addEventListener('click', this.nextEvent)
    }
	checkDirection() {
		if (this.touchendX + 100 < this.touchstartX) this.next();
		if (this.touchendX > this.touchstartX + 100) this.prev();
	}
}

customElements.define('quiz-slider', QuizSlider);
